<div class="dashboard">

  <!-- Header -->
  <div class="header-card">

    <div class="header-top">
    <button mat-icon-button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

    <div class="patient-header">
      <div class="avatar">
        {{
        (pdpmData?.PDPMPatientOverview?.PatientName?.split(' ')[0]?.charAt(0) || '')
        +
        (pdpmData?.PDPMPatientOverview?.PatientName?.split(' ').slice(-1)[0]?.charAt(0) || '')
      }}
      </div>

      <div class="patient-info">
        <div class="name">{{ pdpmData?.PDPMPatientOverview?.PatientName }}</div>
        <div class="sub-title">
          Age {{ pdpmData?.PDPMPatientOverview?.PatientAge }}
          •
          {{ pdpmData?.PDPMPatientOverview?.SurgicalMedical }}
        </div>
        
        <div class="tags">
          <span class="tag" [ngClass]="['red','orange','purple','blue','green','brown'][i % 6]"
            *ngFor="let item of pdpmData?.PDPMPatientOverview?.KeyComorbidities; let i=index">

            {{ item.Description }}

          </span>
        </div>
      </div>
    </div>

    <!-- Stats -->
    <div class="top-stats">

      <div class="stat-box">
        <div class="label">Est. LOS</div>
        <div class="value">{{ pdpmData?.PDPMStay?.EstimatedLOS }}</div>       
      </div>

      <div class="stat-box">
        <div class="label">CBSA</div>
        <div class="value">{{ pdpmData?.PDPMRates?.CBSAClassification }}</div>        
      </div>

      <div class="stat-box">
        <div class="label">Daily rate (Day 4+)</div>
        <div class="value">{{ pdpmData?.PDPMRates?.FinalDailyPatientRate }}</div>       
      </div>

      <div class="stat-box">
        <div class="label">NTA add-on (Days 1-3)</div>
        <div class="value">{{ pdpmData?.PDPMRates?.TotalNTAAddOnDays1To3 }}</div>        
      </div>

      <div class="stat-box">
        <div class="label">30-day projection</div>
        <div class="green-value">{{ pdpmData?.PDPMRates?.Projection30Day }}</div>       
      </div>

      <div class="stat-box">
        <div class="label">100-day projection</div>
        <div class="green-value">{{ pdpmData?.PDPMRates?.Projection100Day }}</div>       
      </div>

    </div>
  </div>


  <div class="content-grid">
   
    <div class="card">
      <h3>PDPM COMPONENTS</h3>       
      <div class="component-row" *ngFor="let item of componentList; let last = last" [class.no-border]="last"
       style="cursor: pointer;" (click)="onPDPMClick()" matTooltip="Click for details">

        <div class="left">
          <div class="icon" [ngClass]="item.color">
            {{ item.icon }}
          </div>

          <div>
            <div class="title">
              {{ item.title }}
            </div>
           
            <div class="desc-row">
              <div class="desc">
                {{ item.data.ClinicalCategory }}
              </div>

              <mat-icon class="view-icon" matTooltip="{{ item.data.Description }}">
                info
              </mat-icon>
            </div>
          </div>
        </div>

        <div class="right">
          <span class="code">
            {{ item.data.CMG }}
          </span>

          <span *ngIf="item.title!='Assessment_Indicator'">
            {{ item.data.EstRate }}
            / {{ item.data.CaseMixIndex }}
            / {{ item.data.HIPPSCharacter }}
          </span>

          <span *ngIf="item.title=='Assessment_Indicator'">
            {{ item.data.assessment_indicator_code }}
            / {{ item.data.assessment_type }}           
          </span>
        </div>

      </div>
    </div>

    <!-- HIPPS -->
    <div class="card">
      <h3>HIPPS CODE</h3>

      <div class="hipps-row">

        <div class="hipps-box blue">
          <div>{{ pdpmData?.PDPMHippsCode?.HIPPSCode?.charAt(0) }}</div>
          <span>PT/OT</span>
        </div>

        <div class="hipps-box green">
          <div>{{ pdpmData?.PDPMHippsCode?.HIPPSCode?.charAt(1) }}</div>
          <span>SLP</span>
        </div>

        <div class="hipps-box yellow">
          <div>{{ pdpmData?.PDPMHippsCode?.HIPPSCode?.charAt(2) }}</div>
          <span>Nursing</span>
        </div>

        <div class="hipps-box red">
          <div>{{ pdpmData?.PDPMHippsCode?.HIPPSCode?.charAt(3) }}</div>
          <span>NTA</span>
        </div>

        <div class="hipps-box gray">
          <div>{{ pdpmData?.PDPMHippsCode?.HIPPSCode?.charAt(4) }}</div>
          <span>5-Day</span>
        </div>

      </div>

      <p class="hipps-text">
        {{ pdpmData?.PDPMHippsCode?.BriefExplanation?.PT_OT }}
        ·
        {{ pdpmData?.PDPMHippsCode?.BriefExplanation?.SLP }}
        ·
        {{ pdpmData?.PDPMHippsCode?.BriefExplanation?.Nursing }}
        ·
        {{ pdpmData?.PDPMHippsCode?.BriefExplanation?.NTA }}
        ·
        {{ pdpmData?.PDPMHippsCode?.BriefExplanation?.AssessmentIndicator }}
      </p>

      <br>
      <h3>NTA POINT BREAKDOWN</h3>

      <div class="bar-item" *ngFor="let item of NTAPointsBreakdown">
        <div class="bar-head">
          <span>{{ item.Condition }} ({{ item.SourceCode }})</span>
          <span class="point">{{ item.Points }} pts</span>
        </div>

        <div class="progress red">
          <div [style.width]="(item.Points * 20) + '%'"></div>
        </div>
      </div>

      <div class="total">
       Total <strong>{{ totalPoints }} pts → tier {{ pdpmData?.PDPMComponentBreakdown?.NTA?.CMG }}</strong>
     </div>

     
    </div>


    <!-- KEY SERVICES -->
    <div class="card">     
      <h3 #keyServicesHeading>KEY SERVICES</h3>       

      <div class="pill" *ngFor="let service of pdpmData?.PDPMKeyServices" 
        style="cursor: pointer;" (click)="onkeyServicesClick()" matTooltip="Click for details">
        {{ service.Service }}

      </div>
      <br>
      <hr>
      <br>
      <p class="footer-note">
        <strong>Est. LOS:</strong>
        {{ pdpmData?.PDPMStay?.EstimatedLOS || 'N/A' }}
        <br>

        <strong>Justification:</strong>
        {{ pdpmData?.PDPMStay?.Justification || 'No justification available.' }}
      </p>
    </div>


    <!-- RISK -->
    <div class="card">
      <h3 class="risk-title">RISK & OPTIMIZATION OPPORTUNITIES</h3>

      <div class="risk-item" *ngFor="let risk of pdpmData?.PDPMRiskOptimizationOpportunities; let i = index">

        <div class="number">
          {{ i + 1 }}
        </div>

        <div>
          <div class="risk-heading">
            {{ risk.Risk }}
          </div>

          <div class="risk-desc">
            {{ risk.Description }}
          </div>
        </div>

      </div>
    </div>
   
  </div>
</div>